import { DateTime } from 'luxon';

/**
 * The contract between the voice panel and whatever turns a sentence into
 * form fields. Types only — this file is in the main bundle; the parser itself
 * (local-parser/) is a lazy chunk. Plan §7.3.
 */

export type Confidence = 'high' | 'medium' | 'low';

export interface Parsed<T> {
  value: T;
  confidence: Confidence;
  /** Shown under the form when the parser guessed ("You didn't say AM or PM…"). */
  note?: string;
}

export interface ParseContext {
  /** In the host's own zone. */
  now: DateTime;
  /** navigator.language, e.g. 'en-IN'. */
  locale: string;
  /** Popular categories plus the host's own. */
  categories: string[];
}

export interface ParseResult {
  eventName: Parsed<string> | null;
  category: (Parsed<string> & { isNew: boolean }) | null;
  /** date is yyyy-MM-dd; time is the form's slot format, "3:00 PM". */
  start: Parsed<{ date: string; time: string }> | null;
  durationMinutes: Parsed<number> | null;
  hostedBy: Parsed<string> | null;
  /** True when a Hindi/Hinglish word rule fired — analytics only. */
  hinglish: boolean;
}

export interface EventDetailsParser {
  parse(text: string, ctx: ParseContext): ParseResult;
}

/** How many fields came back at all. */
export function filledCount(r: ParseResult): number {
  return [r.eventName, r.category, r.start, r.durationMinutes, r.hostedBy].filter(Boolean).length;
}

/** Loads the parser chunk. Kicked off when the mic opens, so it downloads while the host speaks. */
export function loadLocalParser(): Promise<EventDetailsParser> {
  return import('./local-parser/local-event-parser').then(m => new m.LocalEventParser());
}
